import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ProductListKeyItem from './ProductListKeyItem';
import {
  KitIcon,
  NonReturnableIcon,
  RemanufacturedIcon,
  ReplacementPartIcon,
  SuccessIcon
} from 'cat-ecommerce-alloy';

function ProductListKey({ hasCatalogEntries }) {
  const [t] = useTranslation();

  const factoryFitContent = (
    <>
      <p className="text-xs my-2 color-dark-gray text-sans-serif fw-bold">
        {t('FACTORY_FIT_MESSAGE')}
      </p>
      <p className="text-xs mb-0 color-dark-gray text-sans-serif">
        {t('FACTORY_FIT_TEXT')}
      </p>
    </>
  );

  return hasCatalogEntries ? (
    <section className="mb-4 mb-md-5" data-testid="ProductListKey">
      <h3 className="display-3 h3 mb-3 text-xl">{t('PLP_KEY')}</h3>
      <div className="d-md-flex flex-md-row">
        <div className="w-100 me-md-4">
          <ProductListKeyItem
            icon={SuccessIcon}
            iconGreen
            title={t('PART_FACTORY_FIT')}
            message={factoryFitContent}
          />
        </div>
        <hr className="d-md-none my-2" />
        <div className="w-100">
          <ProductListKeyItem
            icon={RemanufacturedIcon}
            title={t('CAT_QO_REMANUFACTURED')}
          />
          <ProductListKeyItem
            icon={NonReturnableIcon}
            title={t('NON_RETURNABLE')}
          />
          <ProductListKeyItem icon={KitIcon} title={t('KIT')} />
          <ProductListKeyItem
            icon={ReplacementPartIcon}
            title={t('REPLACED')}
          />
        </div>
      </div>
    </section>
  ) : null;
}

ProductListKey.propTypes = {
  hasCatalogEntries: PropTypes.bool
};

export default ProductListKey;
